import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function NewParty() {
  const navigate = useNavigate();
  const [category, setCategory] = useState("");
  const [selectedFriends, setSelectedFriends] = useState([]);
  const [friendSuggestions, setFriendSuggestions] = useState([]);
  const [friendInput, setFriendInput] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    axios
      .get("https://verbalvortex-server.onrender.com/auth/friends", {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        setFriendSuggestions(response.data);
      })
      .catch((error) => {
        console.error("Error fetching friends:", error);
      });
  }, []);

  const handleAddFriend = () => {
    if (selectedFriends.length >= 3) {
      setErrorMessage("You cannot add more friends.");
      return;
    }

    const friend = friendSuggestions.find((f) => f.username === friendInput);
    if (friend && !selectedFriends.includes(friend)) {
      setSelectedFriends([...selectedFriends, friend]);
      setFriendInput("");
      setErrorMessage("");
    } else {
      setErrorMessage("Friend not found or already added.");
    }
  };

  const handleRemoveFriend = (username) => {
    setSelectedFriends(selectedFriends.filter((f) => f.username !== username));
    setErrorMessage("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedFriends.length < 1) {
      setErrorMessage("You must invite at least one friend.");
      return;
    }

    const playerIds = selectedFriends.map((friend) => friend.id);

    axios
      .post(
        "https://verbalvortex-server.onrender.com/games",
        {
          category,
          players: playerIds,
        },
        {
          headers: {
            accessToken: localStorage.getItem("accessToken"),
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        navigate("/friends");
      })
      .catch((error) => {
        console.error("Error starting game:", error);
        setErrorMessage("Failed to start game. Please try again.");
      });
  };

  return (
    <div className="NewParty">
      <div className="NewParty__form">
        <h2>Start a New Party</h2>
        <form onSubmit={handleSubmit}>
          <div className="NewParty__form__Categories">
            <label className="NewParty__form__titles">Select Category:</label>
            <div>
              <label>
                <input
                  type="radio"
                  value="Tech"
                  checked={category === "Tech"}
                  onChange={(e) => setCategory(e.target.value)}
                />
                Tech
              </label>
            </div>
            <div>
              <label>
                <input
                  type="radio"
                  value="Sports"
                  checked={category === "Sports"}
                  onChange={(e) => setCategory(e.target.value)}
                />
                Sports
              </label>
            </div>
            <div>
              <label>
                <input
                  type="radio"
                  value="Food"
                  checked={category === "Food"}
                  onChange={(e) => setCategory(e.target.value)}
                />
                Food
              </label>
            </div>
          </div>
          <div>
            <label className="NewParty__form__titles">Selected Friends:</label>
            {selectedFriends.map((friend) => (
              <div key={friend.id}>
                {friend.username}
                <button
                  type="button"
                  onClick={() => handleRemoveFriend(friend.username)}
                >
                  Eliminate
                </button>
              </div>
            ))}
          </div>
          <div className="NewParty__form__AddFriend">
            <input
              className="NewParty__form__input"
              type="text"
              value={friendInput}
              onChange={(e) => setFriendInput(e.target.value)}
              placeholder="Type a friend's username"
              list="friend-suggestions"
            />
            <datalist id="friend-suggestions">
              {friendSuggestions.map((friend) => (
                <option key={friend.id} value={friend.username} />
              ))}
            </datalist>
            <button
              className="NewParty__form__AddFriendButton"
              type="button"
              onClick={handleAddFriend}
            >
              Add Friend
            </button>
          </div>
          {errorMessage && <div className="error">{errorMessage}</div>}
          <button id="StartPartyButton" type="submit">
            Start Party
          </button>
        </form>
      </div>
    </div>
  );
}

export default NewParty;
